import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../cn';
import type { PageContainerElement } from './types';

export type PageContainerProps = HTMLAttributes<HTMLElement> & {
  as?: PageContainerElement;
  stack?: boolean;
  children: ReactNode;
};

export const PageContainer = ({
  as: Component = 'div',
  stack = false,
  className,
  children,
  ...props
}: PageContainerProps) => (
  <Component className={cn('page-container w-full', stack && 'page-stack', className)} {...props}>
    {children}
  </Component>
);
